import type {HostMap} from '../../../types'

export const PRODUCTION = {
  account: 'delivery-frontend-account.taxi.yandex.net',
  auth: 'delivery-frontend-auth.taxi.yandex.net',
  order: 'delivery-frontend-order.taxi.yandex.net',
  route: 'delivery-frontend-route.taxi.yandex.net',
  tariffs: 'delivery-frontend-tariffs-lb.taxi.yandex.net',
  yaAuthProxy: {
    default: 'ya-authproxy.taxi.yandex.net',
    authorized: 'ya-authproxy.taxi.yandex.ru',
  },
  s3: {
    default: 'yastatic.net',
    inner: 's3.mds.yandex.net',
  },
  avatars: 'avatars.mds.yandex.net',
  passport: {
    default: 'passport.yandex.ru',
    id: 'id.yandex.ru',
    api: 'api.passport.yandex.ru',
  },
  rum: 'yandex.ru',
  cspReport: 'csp.yandex.net',
  metrica: {default: 'mc.yandex.ru'},
  forms: {default: 'forms.yandex.ru'},
  maps: {
    default: 'api-maps.yandex.ru',
  },
} as const satisfies HostMap
